import theme from "./theme";

const DevicesMediaMobileFirst = {
  mobile: `@media (min-width: ${theme.breakPoints.sm})`,
  tablet: `@media (min-width: ${theme.breakPoints.md})`,
  tabletLarge: `@media (min-width: ${theme.breakPoints.lg})`,
  desktop: `@media (min-width: ${theme.breakPoints.xl})`,
  desktopLarge: `@media (min-width: ${theme.breakPoints.xxl})`,
};

export default DevicesMediaMobileFirst;
